/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'

import { EuiButton, EuiButtonEmpty, EuiFlexGroup, EuiFlexItem } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import useBillingNotificationsNav from '../../../hooks/useBillingNotificationsNav'
import { type Budget } from '../../types'

type Props = {
  budget: Budget
  onClose: () => void
}

const ActionButtons: FunctionComponent<Props> = ({ budget, onClose }) => {
  const { goToEditBudget } = useBillingNotificationsNav()

  const handleEditBudget = () => goToEditBudget(budget)

  return (
    <EuiFlexGroup justifyContent='spaceBetween'>
      <EuiFlexItem grow={false}>
        <EuiButtonEmpty
          data-test-subj='billing.notifications.budgets.budget-details.button.close'
          type='button'
          onClick={onClose}
        >
          <FormattedMessage
            id='billing.notifications.budgets.budget-details.button.close'
            defaultMessage='Close'
          />
        </EuiButtonEmpty>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiButton
          color='primary'
          data-test-subj='billing.notifications.budgets.budget-details.button.edit'
          fill={true}
          onClick={handleEditBudget}
          size='m'
          type='button'
        >
          <FormattedMessage
            id='billing.notifications.budgets.budget-details.button.edit'
            defaultMessage='Edit budget'
          />
        </EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
  )
}

export default ActionButtons
